import linkViewModel from '@vimcar/mvvm/linkViewModel'
import ScrollHint from '@vimcar/shared-components/components/ScrollHint'
import * as React from 'react'

import type { ViewModel } from './viewModel'

import {
  CUSTOM_ORDER_NOW,
  CUSTOM_SEND_REQUEST,
  CUSTOM_SEND_REQUEST_REQUIRED_MESSAGE,
  CUSTOM_NUMBER_OF_CARS,
  CUSTOM_CONTACT_INFO,
  CUSTOM_TEXT_ONLY,
  CUSTOM_WORKSHOP_TIME_INTERVAL,
  CUSTOM_ODOMETER_START,
  CUSTOM_ODOMETER_END,
  CUSTOM_ODOMETER_DATED,
  CUSTOM_TRIPS_TIME_INTERVAL,
  CUSTOM_CONTRACT_INPUT,
  CUSTOM_TAXOFFICE_INPUT,
  CUSTOM_CAR_COMPATIBLE,
  CUSTOM_CAR_INPUT,
  CUSTOM_LINKS_ONLY,
} from '../../utils/constants'
import CheckboxesNode from '../CheckboxesNode'
import CustomCarInput from '../CustomCarInput'
import CustomCloseAndOrderNow from '../CustomCloseAndOrderNow'
import CustomContractIdInput from '../CustomContractIdInput'
import CustomDatedOdometerInput from '../CustomDatedOdometerInput'
import CustomLinksOnly from '../CustomLinksOnly'
import CustomNumberOfCars from '../CustomNumberOfCars'
import CustomOdometerInput from '../CustomOdometerInput'
import CustomSendContactInformation from '../CustomSendContactInformation'
import CustomSendRequest from '../CustomSendRequest'
import CustomSendRequestRequiredMessage from '../CustomSendRequestRequiredMessage'
import CustomTaxOfficeInput from '../CustomTaxOfficeInput'
import CustomTextAndIcon from '../CustomTextAndIcon'
import CustomTextOnly from '../CustomTextOnly'
import CustomTimeInterval from '../CustomTimeInterval'
import GenericComplexStep from '../GenericComplexStep'
import GenericOptionStep from '../GenericOptionStep'
import styles from './styles.css'
import mkViewModel from './viewModel'

type Props = {
  viewModel: ViewModel
}

const Root = ({ viewModel }: Props) => (
  <ScrollHint containerClassName={styles.contentContainer} showShadowTop>
    <div className={styles.scrollContent}>
      {viewModel.showSelectNode && (
        <GenericOptionStep state={viewModel.state} />
      )}
      {viewModel.showComplexNode && (
        <GenericComplexStep state={viewModel.state} />
      )}
      {viewModel.showCheckboxesNode && (
        <CheckboxesNode state={viewModel.state} />
      )}
      {viewModel.customNodeName === CUSTOM_ORDER_NOW && (
        <CustomCloseAndOrderNow state={viewModel.state} />
      )}
      {viewModel.customNodeName === CUSTOM_SEND_REQUEST && (
        <CustomSendRequest state={viewModel.state} />
      )}
      {viewModel.customNodeName === CUSTOM_SEND_REQUEST_REQUIRED_MESSAGE && (
        <CustomSendRequestRequiredMessage state={viewModel.state} />
      )}
      {viewModel.customNodeName === CUSTOM_TEXT_ONLY && (
        <CustomTextOnly state={viewModel.state} />
      )}
      {viewModel.customNodeName === CUSTOM_NUMBER_OF_CARS && (
        <CustomNumberOfCars state={viewModel.state} />
      )}
      {viewModel.customNodeName === CUSTOM_CONTACT_INFO && (
        <CustomSendContactInformation state={viewModel.state} />
      )}
      {(viewModel.customNodeName === CUSTOM_WORKSHOP_TIME_INTERVAL ||
        viewModel.customNodeName === CUSTOM_TRIPS_TIME_INTERVAL) && (
        <CustomTimeInterval state={viewModel.state} />
      )}
      {viewModel.customNodeName === CUSTOM_ODOMETER_START && (
        <CustomOdometerInput start state={viewModel.state} />
      )}
      {viewModel.customNodeName === CUSTOM_ODOMETER_END && (
        // @ts-expect-error@2741
        <CustomOdometerInput state={viewModel.state} />
      )}
      {viewModel.customNodeName === CUSTOM_ODOMETER_DATED && (
        <CustomDatedOdometerInput state={viewModel.state} />
      )}
      {viewModel.customNodeName === CUSTOM_CONTRACT_INPUT && (
        <CustomContractIdInput state={viewModel.state} />
      )}
      {viewModel.customNodeName === CUSTOM_TAXOFFICE_INPUT && (
        <CustomTaxOfficeInput state={viewModel.state} />
      )}
      {viewModel.customNodeName === CUSTOM_CAR_COMPATIBLE && (
        <CustomTextAndIcon state={viewModel.state} />
      )}
      {viewModel.customNodeName === CUSTOM_CAR_INPUT && (
        <CustomCarInput state={viewModel.state} />
      )}
      {viewModel.customNodeName === CUSTOM_LINKS_ONLY && (
        // @ts-expect-error@2741
        <CustomLinksOnly state={viewModel.state} />
      )}
    </div>
  </ScrollHint>
)

// @ts-expect-error@2345
const component = linkViewModel(mkViewModel, Root)
component.displayName = 'Root'
export default component
